export default  {
  bindings: {
    treatments: '<'
  },
  controller: 'treatmentSingleSelectController',
  template: require('../views/treatment.single.select.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/treatment/components/treatment.single.select.component.js